import type { FieldOf } from "@fobu/schema";

type Sepa = FieldOf<"sepa">;

/** Gläubiger-Identifikationsnummer: Länderkennung, Prüfziffern, Geschäftsbereich (wird nicht geprüft), nationale Kennung. */
export function validCreditorId(raw: string): boolean {
  const id = raw.replace(/\s+/g, "").toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{3}[A-Z0-9]{1,28}$/.test(id)) return false;
  const moved = id.slice(7) + id.slice(0, 4);
  let rest = 0;
  for (const ch of moved) {
    const d = /[A-Z]/.test(ch) ? String(ch.charCodeAt(0) - 55) : ch;
    for (const digit of d) rest = (rest * 10 + Number(digit)) % 97;
  }
  return rest === 1;
}

/** Standard-Mandatstext (SEPA-Basislastschrift) – Platzhalter für den Zahlungsempfänger. */
export function mandateText(field: Sepa, lang = "de"): string {
  const name = field.creditorName.trim() || (lang.startsWith("de") ? "den Zahlungsempfänger" : "the creditor");
  if (!lang.startsWith("de"))
    return `By signing this mandate form, I authorise ${name} to send instructions to my bank to debit my account${field.recurring ? " (recurring payments)" : " (one-off payment)"} and my bank to debit my account in accordance with the instructions from ${name}. As part of my rights, I am entitled to a refund from my bank under the terms and conditions of my agreement with my bank. A refund must be claimed within eight weeks starting from the date on which my account was debited.`;
  return `Ich ermächtige ${name}, ${field.recurring ? "Zahlungen" : "eine Zahlung"} von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von ${name} auf mein Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.`;
}

/** Mandatsreferenz (max. 35 Zeichen, erlaubt A–Z, 0–9 und +?/-:().,') aus der Antwort-ID. */
export const mandateReference = (submissionId: string, prefix = "FOBU") => `${prefix}-${submissionId.toUpperCase().replace(/[^A-Z0-9]/g, "")}`.slice(0, 35);
